import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { AppConfigService } from '@justonweb/core';
import { NotificationHandler } from '@justonweb/notification';
import { TranslocoService } from '@jsverse/transloco';
import { TestEnvironmentComponent } from '@justonweb/dialogs';
import { filter, take } from 'rxjs/operators';

export enum LoginType {
  Citizen = 'citizen',
  Lawyer = 'lawyer',
  Organisation = 'organisation',
  LawyerCard = 'lawyerCard',
  Staff = 'staff',
  Justice = 'justice',
}

export enum LoginUrlKeys {
  LoginUrlCitizenNl = 'loginUrlCitizenNl',
  LoginUrlCitizenFr = 'loginUrlCitizenFr',
  LoginUrlCitizenDe = 'loginUrlCitizenDe',

  LoginUrlLawyerNl = 'loginUrlLawyerNl',
  LoginUrlLawyerFr = 'loginUrlLawyerFr',
  LoginUrlLawyerDe = 'loginUrlLawyerDe',

  LoginUrlOrganisationNl = 'loginUrlOrganisationNl',
  LoginUrlOrganisationFr = 'loginUrlOrganisationFr',
  LoginUrlOrganisationDe = 'loginUrlOrganisationDe',

  LoginUrlLawyerCardNl = 'loginUrlLawyerCardNl',
  LoginUrlLawyerCardFr = 'loginUrlLawyerCardFr',
  LoginUrlLawyerCardDe = 'loginUrlLawyerCardDe',

  LoginUrlStaffNl = 'loginUrlStaffNl',
  LoginUrlStaffFr = 'loginUrlStaffFr',
  LoginUrlStaffDe = 'loginUrlStaffDe',

  LoginUrlJusticeNl = 'loginUrlJusticeNl',
  LoginUrlJusticeFr = 'loginUrlJusticeFr',
  LoginUrlJusticeDe = 'loginUrlJusticeDe',
}

@Component({
    selector: 'jow-justonweb-login',
    templateUrl: './justonweb-login.component.html',
    styleUrls: ['./justonweb-login.component.scss'],
    standalone: false
})
export class JustonwebLoginComponent implements OnInit {
  LoginType = LoginType;

  @ViewChild('lawyerLoginDialog', { read: TemplateRef }) lawyerLoginDialog: TemplateRef<any>;

  constructor(
    private appConfigService: AppConfigService,
    public translationService: TranslocoService,
    private notificationHandler: NotificationHandler,
    private route: ActivatedRoute,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    const message = this.route.snapshot.queryParamMap.get('logoutMessage');
    //Check if we need to notify the user with a logoutMessage
    if (!!message) {
      this.translationService.events$
        .pipe(
          filter((event) => event.type === 'translationLoadSuccess'),
          take(1)
        )
        .subscribe((_) => this.notificationHandler.handle('warning', '', this.translationService.translate(message)));
    }

    if (this.appConfigService.isTestEnvironment) {
      TestEnvironmentComponent.openDialog(this.dialog);
    }
  }

  chooseLawyerLoginOption(): void {
    this.dialog.open(this.lawyerLoginDialog, { panelClass: 'lawyer-login-dialog-panelclass', width: '500px' });
  }

  navigateToLoginUrl(loginType: string) {
    const config = this.appConfigService.getConfig();
    const language = this.translationService.getActiveLang();

    localStorage.setItem('loginType', loginType);

    let loginUrl = '';

    //Set the login url based on loginType and language

    //Citizen
    if (loginType === LoginType.Citizen) {
      if (language === 'nl') {
        loginUrl = config[LoginUrlKeys.LoginUrlCitizenNl];
      } else if (language === 'fr') {
        loginUrl = config[LoginUrlKeys.LoginUrlCitizenFr];
      } else if (language === 'de') {
        loginUrl = config[LoginUrlKeys.LoginUrlCitizenDe];
      }
    }

    //Lawyer
    else if (loginType === LoginType.Lawyer) {
      if (language === 'nl') {
        loginUrl = config[LoginUrlKeys.LoginUrlLawyerNl];
      } else if (language === 'fr') {
        loginUrl = config[LoginUrlKeys.LoginUrlLawyerFr];
      } else if (language === 'de') {
        loginUrl = config[LoginUrlKeys.LoginUrlLawyerDe];
      }
    }

    //LawyerCard
    else if (loginType === LoginType.LawyerCard) {
      if (language === 'nl') {
        loginUrl = config[LoginUrlKeys.LoginUrlLawyerCardNl];
      } else if (language === 'fr') {
        loginUrl = config[LoginUrlKeys.LoginUrlLawyerCardFr];
      } else if (language === 'de') {
        loginUrl = config[LoginUrlKeys.LoginUrlLawyerCardDe];
      }
    }

    //Staff
    else if (loginType === LoginType.Staff) {
      if (language === 'nl') {
        loginUrl = config[LoginUrlKeys.LoginUrlStaffNl];
      } else if (language === 'fr') {
        loginUrl = config[LoginUrlKeys.LoginUrlStaffFr];
      } else if (language === 'de') {
        loginUrl = config[LoginUrlKeys.LoginUrlStaffDe];
      }
    }

    //Organisation
    else if (loginType === LoginType.Organisation) {
      if (language === 'nl') {
        loginUrl = config[LoginUrlKeys.LoginUrlOrganisationNl];
      } else if (language === 'fr') {
        loginUrl = config[LoginUrlKeys.LoginUrlOrganisationFr];
      } else if (language === 'de') {
        loginUrl = config[LoginUrlKeys.LoginUrlOrganisationDe];
      }
    }

    //Justice
    else if (loginType === LoginType.Justice) {
      if (language === 'nl') {
        loginUrl = config[LoginUrlKeys.LoginUrlJusticeNl];
      } else if (language === 'fr') {
        loginUrl = config[LoginUrlKeys.LoginUrlJusticeFr];
      } else if (language === 'de') {
        loginUrl = config[LoginUrlKeys.LoginUrlJusticeDe];
      }
    }

    const connectionReset = this.route.snapshot.queryParamMap.get('connectionReset');
    if (connectionReset) {
      window.location.href = loginUrl + '&connectionReset=' + connectionReset;
    } else {
      window.location.href = loginUrl;
    }
  }
}
